// extracted by mini-css-extract-plugin
export var smallSpinner = "_s5-0";